import { Box, IconButton, Popover, Portal, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { Column, Table } from '@tanstack/react-table'
import { MdSettings } from 'react-icons/md'
import { Checkbox } from 'uikit/Checkbox/Checkbox'
import { Switch } from 'uikit/Switch/Switch'

interface ColumnConfigProps {
  instance: Table<any>
}

export const ColumnConfig = ({ instance }: ColumnConfigProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton variant="ghost" size="xs" aria-label="settings" rounded="full" color="gray.500">
          <MdSettings />
        </IconButton>
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content px="20px" py="16px" w="auto">
            <VStack gap="20px" alignItems="flex-start">
              <Box>
                <Text fontSize="18px" mb={3}>
                  Видимые колонки
                </Text>
                <VStack alignItems="flex-start" gap="6px">
                  {instance.getAllColumns().map((column: Column<any>) => {
                    if (!column.getCanHide()) {
                      return null
                    }

                    return (
                      <Checkbox
                        key={column.id}
                        checked={column.getIsVisible()}
                        onCheckedChange={(e: any) => column.toggleVisibility(e.checked)}
                      >
                        <Text fontSize="14px" whiteSpace="nowrap">
                          {typeof column.columnDef.header === 'function'
                            ? column.id
                            : column.columnDef.header || column.id}
                        </Text>
                      </Checkbox>
                    )
                  })}
                </VStack>
              </Box>
              <Box>
                <Text fontSize="18px" mb={3}>
                  Другое
                </Text>

                <VStack alignItems="flex-start" gap="4px">
                  <Switch
                    label="Мультисортировка"
                    checked={instance.getState().isMultiSort}
                    onCheckedChange={(e: any) => {
                      instance.setIsMultiSort(e.checked)
                    }}
                  />
                </VStack>
              </Box>
            </VStack>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  )
}
